import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const userAuthSelector = (state: State) => state.userAuth.entities;
export const userAuthStatusSelector = (state: State) => state.userAuth.status;

export const userAuthLoadedSelector = isLoaded(userAuthStatusSelector);
export const userAuthRejectedSelector = isRejected(userAuthStatusSelector);
export const usersAuthPendingSelector = isPending(userAuthStatusSelector);
export const shouldLoadUsersSelector = shouldLoad(userAuthStatusSelector);
